<template>
	<cbs-context-menu
		v-if="customerItem.can_update || mixinIsCanCreateCustomer"
		v-bind="$attrs"
		:class="['todo-context-menu', { 'mr-5': displayMode === 'detail' }]"
		:menuListDataBinding="{ class: 'todo-context-menu-list' }"
	>
		<!-- debt extension -->
		<div v-if="mixinIsCanCreateCustomer" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickDebtExtension', customerItem)">
			<i class="nucleo mr-3 nucleo-money-1" />
			{{ $t("Actions.DebtExtension") }}
		</div>
		<!-- Add debts -->
		<div v-if="mixinIsCanCreateCustomer" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickAddDebts', customerItem)">
			<i class="nucleo mr-3 nucleo-money-1" />
			{{ $t("Actions.AddDebts") }}
		</div>
		<!-- Edit -->
		<div v-if="customerItem.can_update" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickAddTTYT', customerItem)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.AddTTYT") }}
		</div>
		<div v-if="customerItem.can_update" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickEdit', customerItem)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.Edit") }}
		</div>
	</cbs-context-menu>
	<span v-else></span>
</template>

<script>
import { customerPermissions, getUserPermissions } from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "CustomerContextMenu",
	mixins: [getUserPermissions({ ...customerPermissions })],
	components: { CbsContextMenu },
	props: {
		customerItem: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickEdit: {},
		onClickCancel: {},
		onClickRecreate: {},
		onClickCreateRequest: {}
	},
	data() {
		return {
			statusActions: {
				0: "",
				1: "onCompleteTodo",
				2: "onClickCancel",
				4: "onSetStatusTodo",
				5: "onSetStatusTodo",
				7: "onClickReject"
			}
		};
	},
	methods: {
		statusEmits(key) {
			return this.statusActions[key];
		}
	}
};
</script>

<style lang="scss" scoped>
.todo-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.todo-context-menu-list {
	.todo-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
